import { FormItemTypes } from 'rds'

const props = [
    {
        label: {
            en: 'Show sale status banner',
            es: 'Mostrar banner de estado de la venta',
        },
        name: 'showSaleStatusBanner',
        type: FormItemTypes.CHECKBOX,
    },
]
export default props
